var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44944 16.9034C9.05892 17.2939 8.42575 17.2939 8.03523 16.9034L0.59283 9.461C0.579492 9.44766 0.566609 9.43404 0.554182 9.42016L0.292893 9.15887C-0.0976308 8.76834 -0.0976309 8.13518 0.292893 7.74465L7.74481 0.292688C8.13534 -0.0978115 8.7685 -0.0978115 9.15903 0.292688L10.1187 1.25249C10.5093 1.64299 10.5093 2.27619 10.1187 2.66669L4.33256 8.45286L10.4092 14.5295C10.7997 14.92 10.7997 15.5531 10.4092 15.9437L9.44944 16.9034Z",
    fill: "#C3C3C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/BackArrow.de40a7a9fbbabb4f158b1515d1ac76ea.svg";
export { ForwardRef as ReactComponent };